//react
import React from "react";

//routing
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { UserLoggedOut } from 'redux/actions';

//firebase
import { auth } from 'assets/firebase';

class LogoutPage extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
          signedOut: false
        };
    }
    
    componentDidMount() {
        
        auth.signOut().then((success) => {
            if(success) {
                this.props.onUserLoggedOut();
                this.setState({signedOut: true});
            }
        });
    }

    render() {

        const intercom = document.createElement("script");
        intercom.innerHTML = 'window.Intercom("shutdown",{ app_id: "l0gl1yia" });';
        document.body.appendChild(intercom);

        if (this.state.signedOut === true) {
            return window.location.replace('https://www.allthingseq.com') //<Redirect to='https://www.allthingseq.com' />
        }

        return (
            <div>
                Signing out ...
            </div>
        )
    }
}


const mapStateToProps = state => {
    return { user: state.user };
}
  
function mapDispatchToProps(dispatch) {
    return bindActionCreators({ onUserLoggedOut: UserLoggedOut }, dispatch);   
}
  
LogoutPage = connect(mapStateToProps, mapDispatchToProps)(LogoutPage);  
export default LogoutPage;


// WEBPACK FOOTER //
// ./src/views/LogoutPage/LogoutPage.jsx